import { createActionGroup, props } from '@ngrx/store';
import { AppleAirPlaySecurityPreset } from '@rocksoft/mdm-sdk-v2';
import { ErrorModel } from '@rocksoft/shared';
import { Category } from '../router/category';

// ============================================================================
// API ACTIONS
// ============================================================================

export const CategoryAirplaySecurityProfilePresetConfigurationApiActions = createActionGroup({
  source: 'Category AirplaySecurity Profile Preset Configuration API',
  events: {
    'Category Profile Preset Configuration Updated Error': props<{
      category: Category;
      error: ErrorModel;
    }>(),
  },
});

// ============================================================================
// VIEW ACTIONS
// ============================================================================

export const CategoryAirplaySecurityProfilePresetConfigurationViewActions = createActionGroup({
  source: 'Category AirplaySecurity Profile Preset Configuration View',
  events: {
    'Profile Preset Configuration Selected': props<{
      category: Category;
      preset: AppleAirPlaySecurityPreset;
      restrict: boolean;
    }>(),
    'Profile Preset Configuration Deselected': props<{
      category: Category;
    }>(),
  },
});
